import angular from 'angular';

import ErrorService from './error-service';
import ErrorNotificationService from './error-notification-service';

export default angular
  .module('error', [])
  .service('ErrorService', ErrorService)
  .service('ErrorNotificationService', ErrorNotificationService);



// WEBPACK FOOTER //
// ./src/modules/utils/rest/error/error-module.js